import React, { useEffect, useState, useRef } from 'react';
import { ApiCore } from '../../api';
import styles from './jumpToWxMini.module.scss';
import { Toast } from 'antd-mobile';
import { DotLoading  } from 'antd-mobile-v5';
import JumpToWxMiniImg from '../../static/images/jumpToWxMini.png';
import utils from '../../utils/utils';

const api = new ApiCore();

function JumpToWxMini(props: any) {

    const mSignRef = useRef();

    useEffect(() => {
        initData();

    }, [props])

    useEffect(() => {
    }, [])

    const initData = () => {
        actionJump();
    }

    // 生成小程序url scheme并跳转
    const actionJump = () => {
        let env = process.env.REACT_APP_ENV;
        let envVersion = 'release';
        console.log(env)
        // 开发环境 开发版
        if (env === 'development') {
            envVersion = 'develop';
        }
        // 测试环境 体验版
        else if (env === 'test') {
            envVersion = 'trial';
        }
        // 生产环境 正式版
        else if (env === 'production') {
            envVersion = 'release';
        }
        const params = {
            appCode: 'EPRO_PT',
            envVersion: envVersion,
            path: 'pages/webview/webview',
            query: ''
        }
        api.getAppSecretScheme(params).then((res: any) => {
            if (res.code == 0) {
                if (!res.data) {
                    Toast.fail(res.message || '获取小程序链接失败', 0.8);
                    return;
                }
                window.location.href = res.data;
            }
        });
    }

    return (
        <div className={styles.jumpToWxMini_content}>
            <div className={styles.img_wrap}>
                <img src={JumpToWxMiniImg} alt="" />
            </div>
            <div className={styles.img_text}>
                正在打开小程序
                <DotLoading color='white' />
            </div>
        </div>
    )
}

export default JumpToWxMini;